// A fresh key also bypasses export files cached before private headers shipped.
// The random value is a request identifier, never an authentication credential.
export function budgetExportUrl(format, month, boutique) {
  const paths = {excel:'/budget/export.xlsx', accounting:'/budget/quickbooks.csv'};
  if (!paths[format]) throw new Error('Unknown budget export format');
  const query = new URLSearchParams({month, boutique, download:crypto.randomUUID()});
  return `${paths[format]}?${query}`;
}
